import { render } from "./PageFooter.vue?vue&type=template&id=80b146d0&scoped=true&ts=true"
import script from "./PageFooter.vue?vue&type=script&lang=ts"
export * from "./PageFooter.vue?vue&type=script&lang=ts"

import "./PageFooter.vue?vue&type=style&index=0&id=80b146d0&lang=scss&scoped=true"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b146d0"]])

export default __exports__